import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig.js";
import ZFIcon from "./ZF_Logo_Blue.svg";
import "./Login.css";
import { Typography } from "@mui/material";

const dataProtectionText = {
  en: 'By sending a message, you confirm that you have taken note of the <a href=\'https://www.zf.com/site/meta/en/data_protection.html\' target="_blank" rel="noopener noreferrer">Data Protection Notice</a> and would like to use the chatbot.Entering personal data is not required.When using this bot no personal related information will be stored during the conversation.Each conversation will be stored for 60 days, each conversation gets a conversation ID which can not be linked to a user ID, IP - address or other personal data.The content of the conversation will be used to enhance the user experience and the quality of the bot.The conversation will not be used for other activities.',
  de: 'Durch das Senden einer Nachricht bestätigen Sie, dass Sie Kenntnis von den <a href="https://www.zf.com/site/meta/en/data_protection.html" target="_blank" rel="noopener noreferrer"> Datenschutzbestimmungen</a> genommen haben und den Bot nutzen möchten. Die Eingabe von personenbezogenen Daten ist nicht notwendig. Während der Nutzung des Bots werden keine personenbezogenen Daten gespeichert. Jede Konversation wird für 60 Tage gespeichert und erhält eine eindeutige, nicht auf den Nutzer zurückzuführende ID. Die Inhalte der Kommunikation werden ausschließlich verwendet, um die Qualität des Bots und die User Experience zu erhöhen.',
};

function Login() {
  const { instance } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const [language, _] = useState(navigator.language || navigator.userLanguage);
  const handleLogin = async () => {
    setIsLoading(true);
    try {
      await instance.loginPopup(loginRequest);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-card">
      <div className="login-header">
        <img src={ZFIcon} className="login-logo" alt="ZF Logo" />
        <h1 className="login-title">IT Help Bot</h1>
      </div>
      <Typography variant="body2" className="login-disclaimer">
        <div
          dangerouslySetInnerHTML={{
            __html:
              language.slice(0, 2) === "de"
                ? dataProtectionText.de
                : dataProtectionText.en,
          }}
        ></div>
      </Typography>
      <button
        className={`login-button ${isLoading ? "loading" : ""}`}
        onClick={handleLogin}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <span className="login-spinner"></span>
            Signing in...
          </>
        ) : (
          "Sign in with SSO"
        )}
      </button>
    </div>
  );
}

export default Login;
